import { axiosNTL } from '../../../services/axios';

import ContentTypeData from "../types/ContentTypeData";


const list = () => axiosNTL
	.get("contentType/getContentType")
	.then((res: any) => {
		let ct: ContentTypeData[] = res.responseObject;

		return Promise.resolve(ct);
	})

export const contentTypeServices = {
	list,
};